<template>
    <v-container class="pa-5" fluid>
        <v-dialog
            :value="isOpen"
            max-width="500px"
            transition="slide-y-transition"
            eager
            @keydown.esc="onClose"
            @click:outside="onClose"
        >
            <v-card>
                <v-card-title>
                    <h1 class="text-subtitle-1">
                        Raport realizacji zamówienia
                    </h1>
                </v-card-title>
                <v-card-text>
                    <v-autocomplete
                        v-model="orderNumber"
                        label="Numer zamówienia"
                        :search-input.sync="orderSearchQuery"
                        :filter="customOrderFilter"
                        :loading="actionLoading.orderSearch"
                        append-icon=""
                        item-value="productionNumber"
                        clearable
                        dense
                        outlined
                        hide-no-data
                        :hint="hintText()"
                    />
                    <v-data-table
                        :headers="headers"
                        height="530"
                        :items="ordersFound"
                        :mobile-breakpoint="0"
                        name="ordersFound"
                        :hide-default-footer="true"
                    >
                        <template #item.productionNumber="{item}">
                            {{ item.productionNumber }}
                        </template>
                        <template #item.actions="{item}">
                            <div class="d-inline-flex">
                                <v-tooltip :open-delay="tooltipDelay" top>
                                    <template #activator="{on}">
                                        <v-btn
                                            icon
                                            v-on="on"
                                            @click="generateReport(item)"
                                        >
                                            <v-icon color="secondary">
                                                mdi-file-pdf-box
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Generuj raport</span>
                                </v-tooltip>
                            </div>
                        </template>
                    </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        color="error"
                        text
                        data-sentry-label="Zamknij"
                        @click="onClose"
                    >
                        Zamknij
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import dateFormatter from '@/mixins/dateFormatter'
import tooltipDelay from '@/mixins/tooltip'
import parse from '@/mixins/parse.js'
import { openPdfFile } from '@/utils/pdfHandler'
import { errorHandler, addSentryBreadcrumb } from '@/utils/errorHandler'

let orderSearchTimer

export default {
    name: 'OrdersListDialog',
    mixins: [
        dateFormatter,
        tooltipDelay,
        parse
    ],
    props: {
        isOpen: {
            type: Boolean
        },
        ordersListData: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            orderSearchQuery: null,
            orderSearchQueryMinLength: 3,
            minLengthPassed: false,
            ordersFound: [],
            actionLoading: {
                orderSearch: false,
                generateReport: false
            },
            orderNumber: null,
            headers: [
                {
                    text: 'Numer zamówienia',
                    value: 'productionNumber',
                    sortable: false,
                    width: 80
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    align: 'left',
                    sortable: false,
                    width: 30
                }
            ]
        }
    },
    watch: {
        orderSearchQuery(value = null) {
            if (value === null || value.length < this.orderSearchQueryMinLength) {
                this.minLengthPassed = false
                this.ordersFound = []
                
                return
            }

            this.actionLoading.orderSearch = true
            this.minLengthPassed = true
            

            clearTimeout(orderSearchTimer)

            orderSearchTimer = setTimeout(() => {
                if (value) {
                    this.searchOrders(value)
                        .catch(error => {
                            errorHandler(error)
                        })
                } else {
                    this.actionLoading.orderSearch = false
                    this.ordersFound = []
                }
            }, 500)
        }
    },
    methods: {
        onClose() {
            this.$emit('on-close')
        },
        customOrderFilter(item, queryText) {
            const order = item.productionNumber.toLowerCase(),
                search = queryText.toLowerCase()

            return order.indexOf(search) > -1
        },
        hintText() {
            if (!this.minLengthPassed) {
                return `Proszę wpisać minimum ${this.orderSearchQueryMinLength} znaki`
            }
        },
        generateReport(order) {
            this.actionLoading.generateReport = true
            this.$store.dispatch('reportsAndAnalysis/orders/printOrderReport', {orderNumber: order.productionNumber})
                .then(response => {
                    openPdfFile(response.data)
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading.generateReport = false
                    this.onClose()
                })
        },
        clearOrderSearch() {
            this.orderSearchQuery = null
            this.ordersFound = []
        },
        async searchOrders(orderNumber = '') {
            addSentryBreadcrumb('ui.action', 'Wyszukiwanie zamówienia')

            return await this.$store.dispatch('orders/findOrderRealizationReport', {
                productionNumber: orderNumber
            })
                .then(response => {
                    this.ordersFound = response.data.results
                    
                    return response.data.results
                })
                .catch(error => {
                    throw error
                })
                .finally(() => {
                    this.actionLoading.orderSearch = false
                })
        }
    }
}
</script>